import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppSettings } from '../appSettings';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  API_PATH: string = AppSettings.API_ENDPOINT;
  accessToken: string = null;

  constructor(private http: HttpClient, private router: Router) {}

  setAccessToken(accessToken: string) {
    this.accessToken = accessToken;
  }

  getAccessToken() {
    return this.accessToken;
  }

  removeAccessToken() {
    this.accessToken = null;
  }

  doAPI(
    type: string,
    route: string,
    data?: any | null,
    urlParams?: HttpParams | null,
    httpHeaders?: HttpHeaders | null
  ): any {
    let url = `${this.API_PATH}${route}`;
    let params = new HttpParams();
    if (urlParams) {
      params = urlParams;
    }

    let headers = new HttpHeaders();
    if (httpHeaders) {
      headers = httpHeaders;
    } else {
      headers = headers.set('AppOrigin', `SegcommercePainel`);

      if (this.accessToken) {
        headers = headers.set('Authorization', `Bearer ${this.accessToken}`);
      }
    }

    switch (type) {
      case 'get':
        return this.http
          .get(url, { params, headers })
          .pipe(catchError(this.handleError));
      case 'post':
        return this.http
          .post(url, data, { params, headers })
          .pipe(catchError(this.handleError));
      case 'patch':
        return this.http
          .patch(url, data, { params, headers })
          .pipe(catchError(this.handleError));
      case 'put':
        return this.http
          .put(url, data, { params, headers })
          .pipe(catchError(this.handleError));
      case 'delete':
        return this.http
          .delete(url, { params, headers })
          .pipe(catchError(this.handleError));
    }
  }

  doGET(route: string, urlParams?: HttpParams): any {
    // console.log('GET');
    return this.doAPI('get', route, null, urlParams);
  }

  doPOST(route: string, data?: any, urlParams?: HttpParams): any {
    // console.log('POST');
    return this.doAPI('post', route, data, urlParams);
  }

  doPATCH(route: string, data?: any, urlParams?: HttpParams): any {
    // console.log('POST');
    return this.doAPI('patch', route, data, urlParams);
  }

  doPUT(route: string, data?: any, urlParams?: HttpParams): any {
    // console.log('PUT');
    return this.doAPI('put', route, data, urlParams);
  }

  doDELETE(route: string, urlParams?: HttpParams): any {
    // console.log('DELETE');
    return this.doAPI('delete', route, null, urlParams);
  }

  public handleError = (error: Response) => {
    if (error.status == 401 && error.statusText == 'Unauthorized') {
      // console.log('handleError: ', error);
      this.router.navigate(['/acessar']);
    }

    // Do messaging and error handling here
    return Observable.throw(error);
  };
}
